import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Contact from "../components/contact";
import Hero from "../commercial/components/hero";
import TriCards from "../commercial/components/triCards";
import PageShell from "../components/pageShell";
import ZigZag from "../commercial/components/zigzag";
import BeforeAfter from "../commercial/components/beforeAfter";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const DefensePage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Success Story - Federal Defense Contractor - Flyby Shine</title>
                        <meta name="description" content="Flyby Shine completed a high-security federal defense contractor facility cleaning within a strict one-day window using rapid-deploy drone technology." />
                        <meta name="keywords" content="Drone Cleaning, Federal Contractor, Security Facility, Rapid Deployment, Defense Industry, Secure Cleaning, Time-Sensitive Cleaning, Drone Technology, High-Security Cleaning, Drone cleaning technology" />
                        <meta property="og:image" content="/assets/federaldefensecontractor.png" />
                    </>
                )}
            </MetaTagHandler>
            <PageShell>
                <Hero
                    subTitle={'Success Story'}
                    title={'Federal Defense Contractor Facility – Confidential Location'}
                    description={`Let's explore how Flyby Shine's drone cleaning services met the critical needs of a high-security federal defense contractor facility.`}
                    banner={
                        {
                            image: '/assets/federaldefensecontractor.png',
                            alt: 'A drone cleaning a secure facility',
                        }
                    }
                />

                <div className="success-story-article">
                    <div className="article-container">
                        <h2>
                            Success Story Breakdown
                        </h2>

                        <div className="case-study-grid">
                            {/* Problem */}
                            <div className="case-study-card" data-aos="fade-up">
                                <div className="card-header">
                                    <i className="material-icons">error_outline</i>
                                    <h3>Problem</h3>
                                </div>
                                <p>
                                    A high-security federal defense contractor needed its facility cleaned within a
                                    <strong> strict one-day window—while the plant was shut down</strong>. Delays or extended downtime
                                    were not an option due to the sensitivity of operations and defense schedules.
                                </p>
                            </div>

                            {/* Solution */}
                            <div className="case-study-card" data-aos="fade-up" data-aos-delay="100">
                                <div className="card-header">
                                    <i className="material-icons">lightbulb_outline</i>
                                    <h3>Solution</h3>
                                </div>
                                <p>
                                    Flyby Shine was brought in as a subcontractor to <strong>execute the full exterior clean using our rapid-deploy drone technology</strong>.
                                    Our drone-powered approach eliminated the need for scaffolding or large crews, ensuring zero delays and maximum precision.
                                </p>
                            </div>

                            {/* Outcome */}
                            <div className="case-study-card" data-aos="fade-up" data-aos-delay="200">
                                <div className="card-header">
                                    <i className="material-icons">check_circle_outline</i>
                                    <h3>Results</h3>
                                </div>
                                <p>
                                    The facility was <strong>fully cleaned and operational before employees returned—on time, on spec, and without disruption</strong>.
                                    We proved again that when time and security matter most, Flyby Shine delivers without compromise.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <BeforeAfter
                    title={"Before And After"}
                    description={"Our drones provide secure, efficient cleaning solutions for high-security facilities where time constraints and precision are critical."}
                    subTitle={"Defense Contractor Cleaning"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Time-Sensitive Execution</li>
                                <li><i className="material-icons">check_circle_outline</i>Secure Operations Protocol</li>
                                <li><i className="material-icons">check_circle_outline</i>Maximum Precision Cleaning</li>
                            </ul>
                        </div>
                    }
                    images={[{
                        firstImage: {
                            imageUrl: '/assets/defensecbefore.png',
                        },
                        secondImage: {
                            imageUrl: '/assets/defensecafter.png',
                        }

                    }
                    ]}
                />

                <Contact />
            </PageShell>
        </>
    )
}

export default DefensePage
